export default __webpack_public_path__ + "static/media/mobile-cropped-nyu.ac182355.png";